import { usePage } from "PFApp/use_page";
import { ApiRoute } from "PFCore/utilities/routes";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

export const useEditEmailTemplatePage = (initPage, { id }) => {
  const { t } = useTranslation();
  const { page, setPage, mergePage, resetPage } = usePage(`email_template/${id}/edit`, initPage);

  const fetchEmailTemplate = ({ id }) =>
    $.ajax({
      url: ApiRoute(id ? `/api/admin/email_templates/${id}` : "/api/admin/email_templates"),
      api_version: 1
    }).then(
      (response) =>
        mergePage({
          emailTemplate: response
        }),
      () =>
        mergePage({
          errors: [t("thereWasAnError")]
        })
    );

  const fetchEmailTemplateSchema = () =>
    $.ajax({
      url: ApiRoute(`/api/admin/email_template_schemas`),
      api_version: 1
    }).then(
      (response) =>
        mergePage({
          emailTemplateSchemas: response
        }),
      () =>
        mergePage({
          errors: [t("thereWasAnError")]
        })
    );

  const initialFetch = () => {
    $.when(fetchEmailTemplate({ id }), fetchEmailTemplateSchema()).always(() => mergePage({ loaded: true }));
  };

  useEffect(() => {
    setPage(initPage);
    return resetPage;
  }, []);

  useEffect(() => {
    initialFetch();
  }, []);

  return { ...page, fetchEmailTemplate, fetchEmailTemplateSchema };
};
